module.exports = __webpack_public_path__ + "static/media/download_done.a894b2d9.svg";